var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBushing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6708 0.160595C7.68983 0.630595 1.83183 2.7106 0.518327 5.1856C0.0553274 6.0576 -0.0686732 9.8771 0.0333268 20.1076L0.170828 33.8576L2.42183 35.3621C5.97283 37.7351 11.4448 38.8456 19.4208 38.8111C29.0023 38.7696 35.3148 37.0566 37.8733 33.8041C38.8758 32.5296 38.9208 31.9121 38.9208 19.4016C38.9208 8.41859 38.7973 6.1536 38.1478 5.2266C35.4848 1.4246 26.0703 -0.606905 14.6708 0.160595ZM25.3623 4.8276C26.2198 5.2706 26.9208 5.9596 26.9208 6.3591C26.9208 9.29809 15.8243 10.0911 12.1618 7.4131C11.2148 6.7206 11.2128 6.6661 12.0938 5.6926C12.5943 5.1396 13.8288 4.4531 14.8373 4.1671C17.3363 3.4581 23.4573 3.8421 25.3623 4.8276Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBushing);
export default __webpack_public_path__ + "static/media/bushing.805f2938ba4e48d2a8f26cf05ed5267c.svg";
export { ForwardRef as ReactComponent };